import socketService, { EventName } from './socket_service';

export { EventName };
export default socketService;
